import Relay from 'react-relay'
import ObjectDetailDefinition from './ObjectDetailDefinition'


const ObjectDetailDefinitionContainer = Relay.createContainer(ObjectDetailDefinition, {
    initialVariables: {
        isDefinitionListVisible: false
    },
    fragments: {
        object: () => Relay.QL`
            fragment on Object {
                ObjObjectNumberTxt,
                ObjObjectTitleTxt,
                ObjObjectTitleSubTxt,
                ObjStandardImage,
                ObjDesigner,
                ObjCategoryVoc,
                ObjDateGrp_DateFromTxt,
                ObjDateGrp_NotesClb,
                ObjDateGrp_Notes3Clb,
                ObjDateTxt,
                ObjMaterialTechniqueTxt,
                ObjDimension,
                ObjObjectNumberGrp_Part1Txt,
                ObjDateGrp_Notes2Clb,
                ObjDateGrp_Notes3Clb,
            }
        `,
    },
});

export default ObjectDetailDefinitionContainer;


// WEBPACK FOOTER //
// ./app/components/Object/Detail/Definition/index.js